/* global axios */
import ApiClient from './ApiClient';

class LeadIntentsAPI extends ApiClient {
  constructor() {
    super('lead_intents', { accountScoped: true, apiVersion: 'v2' });
  }
}

export default new LeadIntentsAPI();
